import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Trash, Check } from "lucide-react";

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  const load = useCallback(async () => { const { data } = await api.get("/contact"); setItems(data); }, []);
  useEffect(() => { load(); }, [load]);

  const markRead = async (id) => { await api.patch(`/contact/${id}`, { read: true }); load(); };
  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/contact/${id}`); toast.success("Silindi"); load();
  };

  return (
    <div data-testid="admin-messages">
      <h1 className="font-display text-3xl md:text-4xl font-black text-ink-900 mb-8">İletişim Mesajları</h1>
      <div className="space-y-3">
        {items.map((m) => (
          <div key={m.id} className={`rounded-2xl border p-5 ${m.read ? "bg-white border-ink-100" : "bg-brand-50/50 border-brand-200"}`}>
            <div className="flex flex-wrap items-start justify-between gap-3 mb-2">
              <div>
                <div className="font-semibold text-ink-900">{m.name}</div>
                <div className="text-xs text-ink-500">{m.email} · {m.phone}</div>
              </div>
              <div className="text-xs text-ink-500">{new Date(m.created_at).toLocaleString("tr-TR")}</div>
            </div>
            {m.subject && <div className="text-sm font-semibold mb-1">{m.subject}</div>}
            <p className="text-sm text-ink-700 whitespace-pre-wrap">{m.message}</p>
            <div className="mt-3 flex gap-2">
              {!m.read && <button onClick={() => markRead(m.id)} className="inline-flex items-center gap-1 rounded-full bg-brand-600 text-white text-xs font-semibold px-3 py-1"><Check className="h-3 w-3" /> Okundu</button>}
              <button onClick={() => del(m.id)} className="inline-flex items-center gap-1 rounded-full bg-red-100 text-red-700 text-xs font-semibold px-3 py-1"><Trash className="h-3 w-3" /> Sil</button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-center py-16 text-ink-500">Mesaj yok.</div>}
      </div>
    </div>
  );
}
